<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical :headerTitle="editingData.__created__ ? '인원관리 추가' : '인원관리 상세'" device="web">
        <template v-slot:body>
          <!-- 작성자/작성일 -->
          <v-form ref="form">
            <v-row no-gutters>
              <v-col md="12" lg="10" class="d-flex justify-space-between align-center">
                <span class="editor-title main_text--text">{{ editingData.__created__ ? '인원관리 추가' : '인원관리 상세' }}</span>
                <v-switch v-model="editingData.useYn" true-value="Y" false-value="N">
                  <template v-slot:label>
                    <span class="ml-2 main_text--text switch-label">{{ editingData.useYn === 'Y' ? '사용' : '미사용' }}</span>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5" class="pr-1">
                <span class="editor-label required">성명</span>
                <v-text-field
                  ref="korNm"
                  v-model="editingData.korNm"
                  solo
                  class="editor_bg"
                  :disabled="!editingData.__created__"
                  :readonly="!editingData.__created__"
                  :rules="rules"
                />
              </v-col>
              <v-col md="6" lg="5" class="pl-1">
                <span class="editor-label">성별</span>
                <v-select v-model="editingData.sexDiv" :items="sexDivList" solo class="editor_bg">
                  <template v-slot:selection="{ item }">
                    <div class="text-center">{{ item }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content @click="$emit('click', item)">
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5" class="pr-1">
                <span class="editor-label">직책/직위</span>
                <v-select v-model="editingData.jbrp" :items="jbrpList" item-text="minorNm" item-value="minorCd" solo class="editor_bg">
                  <template v-slot:selection="{ item }">
                    <div class="text-center">{{ item.minorNm }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content @click="$emit('click', item.minorCd)">
                      <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
              <v-col md="6" lg="5" class="pl-1">
                <span class="editor-label">사번</span>
                <v-text-field ref="sabun" v-model="editingData.sabun" solo class="editor_bg" />
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5" class="pr-1">
                <span class="editor-label required">휴대전화 번호</span>
                <v-text-field ref="hpNo" v-model="editingData.hpNo" :rules="phoneMatch" solo class="editor_bg" :maxLength="11" />
              </v-col>
              <v-col v-if="editingData.__created__" md="6" lg="5" class="pr-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span class="editor-label required">
                      <span>계정 정보</span>
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <div>{{ '인원의 로그인 계정을 의미합니다.\n 계정 비밀번호는 휴대전화번호 뒷 8자리입니다.' }}</div>
                </v-tooltip>
                <div class="d-flex">
                  <v-text-field ref="userCd" v-model="editingData.userCd" solo class="editor_bg" :rules="rules" />
                  <v-btn large width="70" color="primary" class="ml-2 rounded" elevation="0" @click="btnDuplicateConfirm()" :disabled="confirmUserCd"
                    >중복확인</v-btn
                  >
                </div>
              </v-col>
              <v-col v-else md="6" lg="5" class="pr-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span class="editor-label">
                      <span>계정 정보</span>
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <div>{{ '인원의 로그인 계정을 의미합니다.\n 초기 계정 비밀번호는 휴대전화번호 뒷 8자리입니다.' }}</div>
                </v-tooltip>
                <v-text-field ref="userCd" v-model="editingData.userCd" solo class="editor_bg" :disabled="true" :readonly="true" />
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5">
                <v-row no-gutters>
                  <v-col cols="6" class="pr-1">
                    <span class="editor-label">입사일</span>
                    <v-menu
                      ref="menuWorkingAt"
                      v-model="menuWorkingAt"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate(editingData.workingAt)"
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          solo
                          readonly
                          class="editor_bg"
                        />
                      </template>
                      <v-date-picker v-model="editingData.workingAt" no-title scrollable @input="menuWorkingAt = false" />
                    </v-menu>
                  </v-col>
                  <v-col cols="6" class="pl-1">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span class="editor-label">
                          <span>퇴사일</span>
                          <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                        </span>
                      </template>
                      <div>{{ '퇴사일이 입력되면 자동으로 미사용 처리 됩니다.' }}</div>
                    </v-tooltip>
                    <v-menu
                      ref="menuFireAt"
                      v-model="menuFireAt"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate(editingData.fireAt)"
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          solo
                          class="editor_bg"
                          clearable
                          readonly
                          @click:clear="editingData.fireAt = null"
                        />
                      </template>
                      <v-date-picker v-model="editingData.fireAt" no-title scrollable @input="inputFireAt" />
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <span class="editor-label required">
                      <span>사업장 그룹</span>
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <div>{{ '배속된 사업장이 없는 경우 해당 인원의 로그인이 제한 됩니다.' }}</div>
                </v-tooltip>
                <v-autocomplete
                  v-model="editingData.companyGroupList"
                  item-text="compNm"
                  item-value="key"
                  :menu-props="{ offsetY: true }"
                  :items="companyGroupList"
                  placeholder="사업장 그룹"
                  chips
                  deletable-chips
                  solo
                  class="editor_bg"
                  clearable
                  multiple
                  :filter="filterCompanyGroup"
                  :search-input.sync="companyGroupSearch"
                >
                  <template v-slot:prepend-item>
                    <v-sheet class="px-4 pt-4 pb-2">
                      <v-text-field
                        v-model="companyGroupSearch"
                        dense
                        hide-details
                        placeholder="검색어를 입력하세요"
                        prepend-inner-icon="mdi-magnify"
                        clearable
                        @click:clear="companyGroupSearch = ''"
                      ></v-text-field>
                    </v-sheet>
                    <v-divider></v-divider>
                    <v-list-item class="company-group-item">
                      <v-list-item-content>
                        <div class="company-group-grid header">
                          <span>고객사명</span>
                          <span>주소</span>
                          <span>사업장(공사)명</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>

                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-bind="attrs" v-on="on" dense class="company-group-item">
                      <v-list-item-content>
                        <div class="company-group-grid">
                          <span class="ellipsis">{{ item.clntNm }}</span>
                          <span class="ellipsis">{{ item.addrs1 }}</span>
                          <span class="ellipsis">{{ item.compNm }}</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5" class="pr-1">
                <span class="editor-label required">권한 그룹</span>
                <v-select
                  v-model="editingData.groupAuth"
                  :items="groupAuthDataSource"
                  item-text="grpAuthNm"
                  item-value="grpAuthCd"
                  solo
                  class="editor_bg"
                  :rules="rules"
                >
                  <template v-slot:selection="{ item }">
                    <div class="text-center">{{ item.grpAuthNm }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content @click="$emit('click', item.grpAuthCd)">
                      <v-list-item-title>{{ item.grpAuthNm }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
              <v-col md="6" lg="5" class="pl-1">
                <span class="editor-label">고용 구분</span>
                <v-select v-model="editingData.hireGubn" :items="hireList" item-text="minorNm" item-value="minorCd" solo class="editor_bg">
                  <template v-slot:selection="{ item }">
                    <div class="text-center">{{ item.minorNm }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content @click="$emit('click', item.minorCd)">
                      <v-list-item-title>{{ item.minorNm }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="6" lg="5">
                <v-row no-gutters>
                  <v-col cols="6" class="pr-1">
                    <span class="editor-label">접속허용 시작일</span>
                    <v-menu
                      ref="menuconnDtS"
                      v-model="menuconnDtS"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate(editingData.connDtS)"
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          solo
                          readonly
                          class="editor_bg"
                        />
                      </template>
                      <v-date-picker v-model="editingData.connDtS" no-title scrollable @input="menuconnDtS = false" :max="editingData.connDtE" />
                    </v-menu>
                  </v-col>
                  <v-col cols="6" class="pl-1">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span class="editor-label">
                          <span>접속허용 종료일</span>
                          <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                        </span>
                      </template>
                      <div>{{ '접속허용 종료일이 지난 경우 해당인원의 로그인이 제한됩니다.' }}</div>
                    </v-tooltip>
                    <v-menu
                      ref="menuconnDtE"
                      v-model="menuconnDtE"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formatDate(editingData.connDtE)"
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          solo
                          readonly
                          class="editor_bg"
                        />
                      </template>
                      <v-date-picker v-model="editingData.connDtE" no-title scrollable @input="menuconnDtE = false" :min="editingData.connDtS" />
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
              <v-col md="12" lg="10">
                <span class="editor-label">비고</span>
                <v-textarea ref="remark" v-model="editingData.remark" no-resize auto-grow solo class="editor_bg" />
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00004'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(mainData)" @btnSave="btnSave()" @btnDelete="btnDelete()">
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'목록으로'"
              height="92px"
              :icon="'back'"
              @click="btnCancel()"
              :appendDivider="true"
            ></i-icon-button>
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import { saveHrManage, getCompanyGroup, getHrManage, deleteHrManage } from '@/api/baseManage/esgHRManage'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardTop from '@/components/common/iCardTop.vue'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
import { getCurrentDate } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'
import { AesDecrypt, AesEncrypt } from '@/utils/aes256' //cyrptojs 적용(aes256)
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import iIconButton from '@/components/common/iIconButton.vue'
import { getCommonCode } from '@/api/common/commonApi'
import { getGroupData } from '@/api/setting/groupManage'
import clientSelectGridUser from '@/components/esgCommon/clientSelectGridUser.vue'
import { getDuplicateConfirm } from '@/api/system/userManage'

export default {
  mixins: [baseview],
  components: {
    'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    iCardRight,
    iIconButton,
    ProcedureComponent,
    clientSelectGridUser,
  },
  data() {
    return {
      initCompId: '',
      rules: [
        (value) => {
          if (value) return true
          return '필수입력 값입니다.'
        },
      ],
      phoneMatch: [
        (value) => {
          if (value) return true
          return '올바르지 않은 전화번호 형식입니다. 숫자만 입력하세요.(-없이 11자리)'
        },
      ],
      menuStDate: false,
      menuEdDate: false,
      buttonUseList: ['btnSearch', 'btnSave', 'btnDelete'],
      mainData: {}, //
      editingData: {},
      jbrpList: [],
      hireList: [],
      grounAuthList: [],
      groupAuthDataSource: [],
      companyGroupList: [],
      companyGroupNames: [],
      companyGroupSearch: '',
      // phonePattern: /^\d{3}-(\d{4}||\d{3})-\d{4}$/i,
      phonePattern: /^\d{11}$/,
      sexDivList: ['남', '여'],
      menuWorkingAt: false,
      menuFireAt: false,
      menuconnDtS: false,
      menuconnDtE: false,
      procedureShow: false,
      confirmFlag: 0,
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.initCompId = this.getCompId()
    this.setComboBoxData()
    // refresh 시 처리
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }

    if (!this.$route.params.data.__created__) {
      this.mainData = this.$route.params.data
      this.btnSearch(this.mainData)
    }
  },

  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      const toRouter = {
        name: 'EsgHRManage',
        params: {
          search: true,
        },
      }
      this.$router.push(toRouter)
    }
    //데이터 초기화
    this.initializeData()
    // 페이지 이동시
    // 추가, 다른 데이터 상세 정보 호출 시
    if (this.$route.params.data) {
      //추가
      if (this.$route.params.data.__created__) {
        this.mainData = {}
        this.editingData = {}
        this.initializeData()
      } else {
        //  페이지 이동 시 , 다른 데이터 상세정보 조회 시
        if (this.editingData.esgHrNo != this.$route.params.data.esgHrNo) {
          this.mainData = this.$route.params.data
          this.btnSearch(this.mainData)
        }
      }
    }
  },
  watch: {},
  computed: {
    confirmUserCd() {
      let value = true
      if (this.editingData.userCd == null) return value
      else if (this.editingData.userCd.match(this.idRegEx) == null) value = true
      else if (this.confirmFlag === 0) value = false
      return value
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    inputFireAt(e) {
      console.log('##### e', e)
      this.menuFireAt = false
      this.editingData.useYn = 'N'
    },
    //새글작성시 데이터 세팅
    initializeData() {
      this.editingData = {
        clntId: this.getClntId(),
        __created__: true,
        useYn: 'Y',
      }
      this.confirmFlag = 0
    },
    //조회 버튼 클릭
    async btnSearch(param) {
      return new Promise((resolve, reject) => {
        this.openLoading()
        getHrManage(param, true)
          .then((response) => {
            if (response.success) {
              if (response.list.length > 0) {
                this.editingData = _.clone(response.list[0])
                this.editingData.hpNo = this.editingData.hpNo.replaceAll('-', '')
                if (this.editingData.companyGroup) {
                  this.editingData.companyGroupList = this.editingData.companyGroup.split(',')
                }
                console.log('@@ this.editingData ==> ', this.editingData)
              } else {
                this.initializeData()
              }
            }
          })
          .catch((error) => {
            console.error('[error] getHrManage()', error)
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    btnDuplicateConfirm() {
      let searchParams = { userCd: this.editingData.userCd }
      if (this.editingData.userCd.trim().length !== 0 || this.editingData.userCd != '') {
        getDuplicateConfirm(searchParams)
          .then((res) => {
            if (res.list === undefined) {
              this.$vToastify.prompt({ body: '사용 가능한 아이디 입니다.', answers: { 확인: true } })
              this.confirmFlag = 1
            } else {
              this.$vToastify.prompt({ body: '이미 사용중인 아이디입니다.', answers: { 확인: true } })
              this.confirmFlag = 0
            }
          })
          .finally(() => {})
      } else {
        this.$vToastify.prompt({ body: '아이디를 입력하세요', answers: { 확인: true } })
      }
    },
    //저장 버튼 클릭
    async btnSave() {
      // 유효성 검사 > 필수 입력 값
      const validate = this.$refs.form.validate()
      if (!validate) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
        return
      }
      if (!this.confirmFlag && this.editingData.__created__) {
        this.vToastify(this.$t('아이디 중복확인을 해주세요.'), 'info')
        return
      }

      // 유효성 검사 > 휴대전화 패턴
      if (this.editingData.hpNo) {
        if (this.editingData.hpNo.match(this.phonePattern) == null) {
          this.vToastify(this.$t('올바르지 않은 전화번호 형식입니다. 숫자만 입력하세요.(-없이 11자리)'), 'info')
          return
        }
      }
      if (!this.editingData.companyGroupList || this.editingData.companyGroupList.length === 0) {
        this.vToastify(this.$t('사업장 그룹을 선택해주세요.'), 'info')
        return
      }
      this.vToastifyPrompt(this.$t('doSaveData'), 'info', (current) => {
        this.openLoading()
        this.editingData.userPs = AesEncrypt(this.editingData.hpNo.slice(-8))
        this.editingData.grpAuthCd = this.editingData.groupAuth
        saveHrManage(this.editingData, true)
          .then((response) => {
            if (response.success) {
              if (this.editingData.__created__) {
                this.mainData = response.map
              }
            }
          })
          .finally(() => {
            this.endLoading()
            this.btnSearch(this.mainData)
          })
      })
    },
    btnDelete() {
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        //yes action
        (current) => {
          this.openLoading('deleting')
          deleteHrManage([this.editingData], true)
            .then((res) => {
              if (res.success) {
                this.$router.go(-1)
              }
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    //목록으로 버튼 클릭
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async (current) => {
        this.$router.go(-1)
        return
      })
    },
    filterCompanyGroup(item, queryText, itemText) {
      const search = (queryText || '').toString().trim().toLowerCase()
      if (!search) {
        return true
      }

      const targets = [item.compNm, item.clntNm, item.addrs1]
      return targets.some((field) => (field || '').toString().toLowerCase().includes(search))
    },
    setComboBoxData() {
      const params = {
        clntId: this.getClntId(),
      }

      Promise.all([getCommonCode('CM007'), getCommonCode('CM013'), getGroupData(), getCompanyGroup(params)]).then((response) => {
        let failedResponse = response.find((element) => !element.success)
        if (failedResponse == null) {
          console.log('[response] setComboBoxData', response)

          //	직책/직위
          this.jbrpList = response[0].list.slice()
          this.jbrpList.unshift({ minorCd: '', minorNm: '' })

          this.hireList = response[1].list.slice()
          // 권한 그룹
          this.groupAuthList = response[2].list.slice()
          this.groupAuthDataSource = this.groupAuthList.filter((element) => element.grpAuthCd)
          //사업장 그룹
          this.companyGroupList = response[3].list.slice()
          console.log('this.companyGroupList', this.companyGroupList)
          this.companyGroupNames = new Map(this.companyGroupList.map((obj) => [obj.compId, obj.compNm]))
        } else {
          this.$vToastify.error({ body: failedResponse.msg })
          this.vToastify(failedResponse.msg ? failedResponse.msg : '', 'error')
        }
      })
    },
  },
}
</script>

<style lang="scss">
.company-group-item {
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.company-group-grid {
  display: grid;
  grid-template-columns: 1.2fr 1.8fr 1.2fr;
  gap: 8px;
  align-items: center;
}

.company-group-grid.header {
  font-size: 15px;
  font-weight: 600;
  color: #1976d2;
}

.company-group-grid .ellipsis {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
